/**
 * Quickview + header search autocomplete.
 * Quickview: Section Rendering ({product.url}?section_id=quickview-content) → dialog.
 * Autocomplete: Shopify Predictive Search API (αντικαθιστά το live Template7+
 * custom search.json — ίδια UX, μηδέν εξωτερικό CDN, annex-listing §3 πρόταση).
 */
(function () {
  // ---------- Card touch-swap (Σ07-11: μηχανισμός ΠΑΛΙΟΥ eshop, owner-proven) ----------
  // Λογική Sidekick/παλιού καταστήματος (owner: «δούλευε εξαιρετικά» σε πραγματικό
  // iOS): ΔΕΝ βασιζόμαστε στο native click του iOS ΚΑΘΟΛΟΥ — η πλοήγηση γίνεται
  // ΠΡΟΓΡΑΜΜΑΤΙΣΤΙΚΑ. touchstart στη ζώνη εικόνας (το <a> — τα κουμπιά quickview/
  // wishlist/ATC είναι ΕΚΤΟΣ και εξαιρούνται): κρατάμε t0 + Χ/Υ + δείχνουμε ΑΜΕΣΩΣ
  // τη 2η φωτο. Στο touchend: (α) μετακίνηση >10px = scroll → αφαίρεση κλάσης,
  // τίποτα άλλο· (β) διάρκεια <250ms = tap → preventDefault (σκοτώνει το αναξιόπιστο
  // native click) + window.location.href· (γ) ≥250ms = κράτημα-παρατήρηση →
  // preventDefault (να ΜΗΝ πλοηγήσει το άφημα) + επαναφορά 1ης με 150ms delay.
  // + pageshow: καθάρισμα κλάσης σε back/bfcache (το γνωστό «κολλημένη 2η φωτο»).
  function clearSwaps() {
    document.querySelectorAll('.product-card__media.is-touch-swap').forEach(function (m) {
      m.classList.remove('is-touch-swap');
    });
  }
  var cardTouch = null; // { link, media, t0, x0, y0 }
  document.addEventListener('touchstart', function (e) {
    var link = e.target.closest('.product-card__link');
    if (!link) { cardTouch = null; return; }
    var media = link.closest('.product-card__media');
    var t = e.touches[0];
    cardTouch = { link: link, media: media, t0: Date.now(), x0: t.clientX, y0: t.clientY };
    if (media && media.querySelector('.product-card__img--secondary')) {
      media.classList.add('is-touch-swap');
    }
  }, { passive: true });
  // touchend ΟΧΙ passive: χρειαζόμαστε preventDefault για να μη fire-άρει
  // το native click (β) και να μην πλοηγήσει το άφημα του κρατήματος (γ)
  document.addEventListener('touchend', function (e) {
    if (!cardTouch) return;
    var ct = cardTouch;
    cardTouch = null;
    var t = e.changedTouches[0];
    var moved = !t || Math.abs(t.clientX - ct.x0) > 10 || Math.abs(t.clientY - ct.y0) > 10;
    var dt = Date.now() - ct.t0;
    if (moved) { // (α) scroll — καμία πλοήγηση, άμεση επαναφορά
      if (ct.media) ct.media.classList.remove('is-touch-swap');
      return;
    }
    if (e.cancelable) e.preventDefault();
    if (dt < 250) { // (β) γρήγορο tap → δική μας πλοήγηση, ντετερμινιστική
      window.location.href = ct.link.href;
    } else { // (γ) κράτημα-παρατήρηση → smooth επιστροφή στην 1η
      setTimeout(function () {
        if (ct.media) ct.media.classList.remove('is-touch-swap');
      }, 150);
    }
  }, { passive: false });
  document.addEventListener('touchcancel', function () {
    cardTouch = null;
    clearSwaps();
  }, { passive: true });
  // bfcache (πίσω από προϊόν): καθάρισε τυχόν κολλημένα swaps στην επιστροφή
  window.addEventListener('pageshow', clearSwaps);

  // ---------- Quickview ----------
  var dialog = document.querySelector('[data-quickview-dialog]');
  if (dialog) {
    var body = dialog.querySelector('[data-quickview-body]');
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quickview]');
      if (btn) {
        e.preventDefault();
        var handle = btn.getAttribute('data-product-handle');
        body.innerHTML = '<p class="qv-loading">Φόρτωση...</p>';
        dialog.showModal();
        fetch('/products/' + handle + '?section_id=quickview-content')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            body.innerHTML = tmp.firstElementChild.innerHTML;
          })
          .catch(function () { body.innerHTML = '<p class="qv-loading">Σφάλμα φόρτωσης.</p>'; });
        return;
      }
      if (e.target.closest('[data-quickview-close]')) dialog.close();
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

    // ---------- variant resolve + qty/subtotal + thumbs (live QV parity, 0β) ----------
    function formatMoney(cents) {
      var n = (cents / 100).toFixed(2).split('.');
      return '€' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
    }

    function qvCurrentVariant(qv) {
      var variants = [];
      try { variants = JSON.parse(qv.querySelector('[data-qv-variants]').textContent); } catch (err) { return null; }
      var radios = qv.querySelectorAll('[data-qv-option]:checked');
      if (!radios.length) {
        var id = parseInt(qv.querySelector('[data-qv-variant-id]').value, 10);
        return variants.find(function (x) { return x.id === id; }) || null;
      }
      var sel = [];
      radios.forEach(function (r) { sel[parseInt(r.getAttribute('data-option-index'), 10)] = r.value; });
      return variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); }) || null;
    }

    function qvUpdateTotal(qv) {
      var v = qvCurrentVariant(qv);
      var totalEl = qv.querySelector('[data-qv-total]');
      var qtyEl = qv.querySelector('[data-qv-qty]');
      if (!v || !totalEl) return;
      var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      totalEl.textContent = formatMoney(v.price * qty);
    }

    document.addEventListener('change', function (e) {
      var qv = e.target.closest('[data-qv]');
      if (!qv) return;

      if (e.target.matches('[data-qv-option]')) {
        // swatch header selected value (live: [data-option-select])
        var sw = e.target.closest('[data-qv-swatch]');
        if (sw) {
          var out = sw.querySelector('[data-selected-value]');
          if (out) out.textContent = e.target.value;
        }
        var v = qvCurrentVariant(qv);
        var atc = qv.querySelector('button[name="add"]');
        if (!v) {
          if (atc) { atc.disabled = true; atc.textContent = 'Μη διαθέσιμο'; }
          return;
        }
        qv.querySelector('[data-qv-variant-id]').value = v.id;
        var price = qv.querySelector('[data-price]');
        if (price) {
          price.textContent = formatMoney(v.price);
          price.classList.toggle('on-sale', !!(v.compare_at_price && v.compare_at_price > v.price));
        }
        var compare = qv.querySelector('[data-qv-compare]');
        if (compare) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compare.hidden = false;
            compare.textContent = formatMoney(v.compare_at_price);
          } else compare.hidden = true;
        }
        var sku = qv.querySelector('[data-sku]');
        if (sku) sku.textContent = v.sku || '';
        if (atc) {
          atc.disabled = !v.available;
          atc.textContent = v.available ? 'Στο Καλάθι' : 'Εξαντλημένο';
        }
        if (v.featured_image && v.featured_image.src) {
          var main = qv.querySelector('[data-qv-main]');
          if (main) { main.src = v.featured_image.src; main.removeAttribute('srcset'); }
        }
        qvUpdateTotal(qv);
        return;
      }

      if (e.target.matches('[data-qv-qty]')) qvUpdateTotal(qv);
    });

    document.addEventListener('click', function (e) {
      var qv = e.target.closest('[data-qv]');
      if (!qv) return;

      var minus = e.target.closest('[data-qv-qty-minus]');
      var plus = e.target.closest('[data-qv-qty-plus]');
      if (minus || plus) {
        var qtyEl = qv.querySelector('[data-qv-qty]');
        if (qtyEl) {
          var val = Math.max(1, parseInt(qtyEl.value, 10) || 1) + (plus ? 1 : -1);
          qtyEl.value = Math.max(1, val);
          qvUpdateTotal(qv);
        }
        return;
      }

      var thumb = e.target.closest('[data-qv-thumb]');
      if (thumb) {
        var main = qv.querySelector('[data-qv-main]');
        if (main) { main.src = thumb.getAttribute('data-src'); main.removeAttribute('srcset'); }
        qv.querySelectorAll('[data-qv-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      }
    });
  }

  // ---------- TASK 62η (owner: «σκουλαρίκια ροζ» ≠ ροζέτα): το submit στέλνει
  // ΣΚΕΤΗ τη λέξη (ακριβές whole-word ταίριασμα — καμία ροζ*→ροζέτα μόλυνση)·
  // αν τα αποτελέσματα βγουν φτωχά (μισογραμμένη λέξη π.χ. «κολ»), η σελίδα
  // /search αυτο-αναβαθμίζει σε wildcard (script στο search.liquid). ----------
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/search"]')) return;
    var inp = f.querySelector('input[name="q"]');
    if (!inp) return;
    // TASK 62: αν το panel έχει λύσει Greeklish→ελληνικά για ΑΥΤΟ το κείμενο,
    // υποβάλλεται το ελληνικό query (αλλιώς το /search δεν θα έβρισκε τίποτα)
    if (f.dataset.effectiveQ && f.dataset.effectiveFor === inp.value.trim()) {
      inp.value = f.dataset.effectiveQ;
    }
  });

  // ---------- Autocomplete (Predictive Search API) — κάθε [data-search-box]:
  // header (desktop) + /search page (το μονοπάτι του κινητού, F3-finding-11) ----------
  document.querySelectorAll('[data-search-box]').forEach(function (box) {
    var input = box.querySelector('input[type="search"]');
    var panel = box.querySelector('[data-search-suggest]');
    if (!input || !panel) return;
    var timer = null;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 3) { panel.hidden = true; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (((data || {}).resources || {}).results || {}).products || [];
            // TASK 62β: κρυφά βοηθητικά προϊόντα εκτός autocomplete
            if (window.__searchExcluded && window.__searchExcluded.length) {
              products = products.filter(function (p) { return window.__searchExcluded.indexOf(p.handle) === -1; });
            }
            if (!products.length) { panel.hidden = true; return; }
            panel.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') === -1 ? '?' : '&') + 'width=90" alt="" loading="lazy">'
                : '';
              return '<a class="search-suggest__item" href="' + p.url + '">' + img +
                '<span class="search-suggest__title">' + p.title + '</span>' +
                '<span class="search-suggest__price">' + p.price + '€</span></a>';
            }).join('') +
            '<a class="search-suggest__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Όλα τα αποτελέσματα →</a>';
            panel.hidden = false;
          })
          .catch(function () { panel.hidden = true; });
      }, 250);
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-search-box]')) {
      document.querySelectorAll('[data-search-box] [data-search-suggest]').forEach(function (p) { p.hidden = true; });
    }
  });
})();
